// routes
import {
  PATH_STUDYREEL,
  PATH_TESTING,
  PATH_RECOMMENDATIONS,
  PATH_COACHING,
  PATH_OVERRIDE,
  PATH_MANAGEMENT,
} from './paths';
// components
import {
  CameraRoll,
  RateReview,
  Inventory,
  School,
  Person,
  Edit,
  LocalLibrary,
  ListAlt,
} from '@mui/icons-material';

import { AuthUser, Role } from '@common/@types/auth';
import React from 'react';

export type BlacklistFunction = (user: AuthUser) => boolean;

export function blockUserNotInRoles(...roles: Role[]): BlacklistFunction {
  return (user: AuthUser) => roles.every((role) => user?.alphaAuthAttributes?.role !== role);
}

// @ts-ignore
const navConfig = [
  {
    subheader: 'Guide Tools',
    items: [
      {
        title: '2hr Overrides',
        path: PATH_OVERRIDE.root,
        icon: <Edit />,
      },
    ],
  },
  {
    subheader: 'StudyReel',
    items: [
      {
        title: 'StudyReel',
        path: PATH_STUDYREEL.root,
        icon: <CameraRoll />,
      },
      {
        title: 'Clip Review',
        path: PATH_STUDYREEL.clipReview.root,
        icon: <RateReview />,
      },
      {
        title: 'Anti Pattern Inventory',
        path: PATH_STUDYREEL.ap_inventory,
        icon: <RateReview />,
        blacklistFunction: (user: AuthUser) =>
          user?.alphaAuthAttributes?.role !== Role.ADMIN &&
          user?.alphaAuthAttributes?.role !== Role.GUIDE,
      },
    ],
  },
  {
    subheader: 'testing',
    items: [
      {
        title: 'bulk assign',
        path: PATH_TESTING.bulkTestAssign,
        icon: <Inventory />,
      },
      {
        title: 'test assignment',
        path: PATH_TESTING.gradeClearedTestAssignment,
        icon: <Inventory />,
      },
      {
        title: 'next best test',
        path: PATH_TESTING.nextBestTest,
        icon: <Inventory />,
      },
    ],
  },
  {
    subheader: 'recommendations',
    items: [
      {
        title: 'recommendations',
        path: PATH_RECOMMENDATIONS.root,
        icon: <School />,
      },
      {
        title: 'skills override',
        path: PATH_RECOMMENDATIONS.skillsOverride,
        icon: <School />,
      },
    ],
  },
  {
    subheader: 'coaching',
    items: [
      {
        title: 'coaching',
        path: PATH_COACHING.root,
        icon: <Person />,
      },
    ],
  },
  {
    subheader: 'management',
    items: [
      {
        title: 'student app roster',
        path: PATH_MANAGEMENT.studentAppRoster,
        icon: <LocalLibrary />,
      },
      {
        title: 'skill plans',
        path: PATH_MANAGEMENT.skillPlan,
        icon: <ListAlt />,
      },
    ],
  },
];

export default navConfig;
